import React, { ComponentProps } from "react";

import { withIssuesConsumer } from "@adsk/acc-issues-common/components/primitive/IssuesConsumer";
import { getStatusColor } from "@adsk/acc-issues-common/utils/status/statusFieldHelpers";
import { Issue } from "@adsk/acc-issues-types";
import { EntityMenuItem } from "@adsk/acc-reference-picker";
import { useCurrentProjectId } from "@adsk/alloy-provider";
import StatusColorIndicator from "@adsk/alloy-react-status-color-indicator";
import Theme from "@adsk/alloy-react-theme";

import { getIssueUrl } from "./helpers/utils";

type IssueEntityCellItemProps = Partial<
  ComponentProps<typeof EntityMenuItem>
> & {
  entity: Issue;
};

export const IssueEntityCellItem: React.ComponentType<IssueEntityCellItemProps> =
  withIssuesConsumer(({ entity, ...rest }: IssueEntityCellItemProps) => {
    const projectId = useCurrentProjectId() as string;
    const { displayId, id: issueId, status, title } = entity;
    const url = getIssueUrl({ projectId, issueId });
    const label = (
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        {status && (
          <StatusColorIndicator
            style={{
              width: 3,
              height: 16,
              cursor: "default",
              backgroundColor: getStatusColor(status),
            }}
          />
        )}
        <span style={{ paddingLeft: 3 }}>{`#${displayId}`}</span>
        <span style={{ paddingLeft: 3, color: Theme.colors.charcoal700 }}>
          {title}
        </span>
      </div>
    );
    return (
      <EntityMenuItem key={entity.id} link={url} label={label} {...rest} />
    );
  });
